<template>
  <div class="tradingview-widget-container">
    <div class="tradingview-widget-container__widget"></div>
    <div class="tradingview-widget-copyright"></div>
  </div>
</template>

<script>
export default {
  mounted() {
    let container = document.getElementsByClassName(
      "tradingview-widget-container"
    )[0];
    // container.replaceChildren();
    const script = document.createElement("script");
    script.src =
      "https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js";
    script.type = "text/javascript";
    script.async = true;
    script.innerHTML = JSON.stringify({
      symbols: [
        {
          proName: "FOREXCOM:SPXUSD",
          title: "S&P 500",
        },
        {
          proName: "BLACKBULL:DJ30.F",
          title: "Dow Jones Futures",
        },
        {
          proName: "INDEX:CAC40",
          title: "CAC 40",
        },
        {
          proName: "XETR:DAX",
          title: "DAX",
        },
        {
          proName: "SPREADEX:FTSE",
          title: "FTSE 100",
        },
        {
          proName: "INDEX:NKY",
          title: "Nikkei 225",
        },
        {
          proName: "KRX:KOSPI",
          title: "KOSPI",
        },
        {
          proName: "HSI:HSI",
          title: "Hang Seng",
        },
        {
          proName: "SSE:000001",
          title: "Shanghai Composite",
        },
        {
          proName: "INDEX:SENSEX",
          title: "SENSEX",
        },
        {
          proName: "NASDAQ:IXIC",
          title: "Nasdaq",
        },
      ],
      showSymbolLogo: true,
      colorTheme: "light",
      isTransparent: false,
      displayMode: "regular",
      locale: "in",
    });
    container.appendChild(script);
  },
};
</script>

<style lang="scss" scoped></style>
